registerComponent("pages/contents", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * ⚠️ SEM JS, de propósito. O arquivo de 2020 era uma cópia do
 * `pages/videos/_videos.js` — o mesmo abre/fecha de `#showSubMenu`, `#btnClose`,
 * `#subMenu` e `.bg-beige` —, mas ESTE Blade nunca teve nenhum dos três
 * primeiros: só o `#subMenu`, e com a classe `.sub-menu-contents`, que a folha
 * desenha como uma fita de links sempre visível (não há regra `.active` para
 * ela). `git log --follow -p` no `index.blade.php` confirma: o markup do menu
 * de vídeos nunca esteve aqui.
 *
 * Em 2020 o corpo rodava — o `Component.init()` corria no `preloaded.before`,
 * antes do `DOMContentLoaded` — e estourava na primeira linha
 * (`showSubMenu.addEventListener` com `showSubMenu` null), dentro do listener,
 * sem derrubar mais nada. Desde a Fase 2 o embrulho `DOMContentLoaded` nunca
 * mais é chamado e o arquivo virou letra morta silenciosa. Tirar o embrulho sem
 * tirar o corpo, como o Passo 5 da fase manda para os três irmãos, trocaria o
 * no-op por um erro de inicialização real em `/central-de-conteudos`,
 * `/central-de-conteudos/{categoria}` e `/central-de-conteudos/tags/{tag}`.
 * Correção 117 do programa.
 */

});
